import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

export default function PublicRescheduleOnlineBookingPage() {
  const { rescheduleToken } = useParams();

  const [step, setStep] = useState(1);

  const [appointment, setAppointment] = useState(null);
  const [code, setCode] = useState('');

  const [selectedDate, setSelectedDate] = useState('');
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [successData, setSuccessData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, [rescheduleToken]);

  const loadData = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `/online-booking/reschedule/${rescheduleToken}`
      );

      setAppointment(response.data);
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível carregar o agendamento.'
      );
    } finally {
      setLoading(false);
    }
  };

  const sendCode = async () => {
    try {
      setError('');

      await api.post(
        '/online-booking/reschedule/start',
        {
          reschedule_token: rescheduleToken,
        }
      );

      window.alert(
        'Código enviado para o e-mail vinculado ao agendamento.'
      );

      setStep(2);
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível enviar o código.'
      );
    }
  };

  const loadAvailability = async () => {
    try {
      setError('');

      const response = await api.post(
        '/online-booking/reschedule/availability',
        {
          reschedule_token: rescheduleToken,
          code,
          professional_id: appointment.professional_id,
          appointment_date: selectedDate,
        }
      );

      setSlots(
        response.data.available_slots || []
      );

      setStep(3);
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível carregar horários.'
      );
    }
  };

  const confirmReschedule = async () => {
    try {
      setError('');

      const response = await api.post(
        '/online-booking/reschedule/confirm',
        {
          reschedule_token: rescheduleToken,
          code,
          professional_id: appointment.professional_id,
          appointment_date: selectedDate,
          start_time: selectedSlot.start_time,
        }
      );

      setSuccessData(response.data);

      setStep(4);
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível remarcar.'
      );
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Carregando...
      </div>
    );
  }

  if (!appointment) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-red-600">
          {error}
        </div>
      </div>
    );
  }

  if (step === 4) {
    return (
      <div className="min-h-screen flex justify-center p-4 bg-gray-50">
        <div className="bg-white rounded-xl shadow p-6 max-w-md w-full space-y-4">

          <h1 className="text-xl font-bold">
            {successData.requires_manual_confirmation
              ? 'Solicitação de remarcação enviada'
              : 'Remarcação realizada'}
          </h1>

          <p>
            {successData.message}
          </p>

          <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-2">
            <p>
              <strong>Nova data:</strong> {successData.appointment.appointment_date}
            </p>

            <p>
              <strong>Novo horário:</strong> {successData.appointment.start_time} às {successData.appointment.end_time}
            </p>

            <p>
              <strong>Status:</strong> {successData.appointment.status}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex justify-center p-4 bg-gray-50">
      <div className="bg-white rounded-xl shadow p-6 max-w-md w-full space-y-4">

        <h1 className="text-xl font-bold">
          Remarcar agendamento
        </h1>

        <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-2">
          <p>
            <strong>Paciente:</strong> {appointment.patient_name}
          </p>

          <p>
            <strong>Profissional:</strong> {appointment.professional_name}
          </p>

          <p>
            <strong>Data atual:</strong> {appointment.appointment_date}
          </p>

          <p>
            <strong>Horário atual:</strong> {appointment.start_time} às {appointment.end_time}
          </p>
        </div>

        {step === 1 && (
          <button
            onClick={sendCode}
            className="w-full bg-purple-600 text-white py-3 rounded-lg"
          >
            Enviar código de confirmação
          </button>
        )}

        {step === 2 && (
          <>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Digite o código recebido"
              className="w-full border rounded-lg px-3 py-2"
            />

            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="w-full border rounded-lg px-3 py-2"
            />

            <button
              onClick={loadAvailability}
              className="w-full bg-purple-600 text-white py-3 rounded-lg"
            >
              Buscar horários
            </button>
          </>
        )}

        {step === 3 && (
          <>
            <div className="grid grid-cols-2 gap-2">
              {slots.map((slot) => (
                <button
                  key={slot.start_time}
                  onClick={() => setSelectedSlot(slot)}
                  className={`py-2 rounded-lg border ${
                    selectedSlot?.start_time === slot.start_time
                      ? 'bg-purple-600 text-white'
                      : 'bg-white'
                  }`}
                >
                  {slot.start_time}
                </button>
              ))}
            </div>

            <button
              disabled={!selectedSlot}
              onClick={confirmReschedule}
              className="w-full bg-purple-600 text-white py-3 rounded-lg disabled:opacity-50"
            >
              Confirmar remarcação
            </button>
          </>
        )}

        {error && (
          <p className="text-red-600 text-sm">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}